/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AuthRoles } from 'jotai/auth';
import { authService } from 'services/auth/AuthService';

const isAdminUser = () => {
  const userRoles = authService.getRoles(process.env.REACT_APP_ROLE_COMPTOOLS_REALM.toString());
  const adminRoles: string[] = [AuthRoles.ADMIN];
  return userRoles && userRoles?.some((item) => adminRoles.includes(item));
};

export default isAdminUser;
